import { Skeleton } from "@storybook";
import { Card } from "components";
import { Fragment } from "react/jsx-runtime";

export const SignInSkelton = () => {
  return (
    <Card className="flex direction-col gap-16 w-480 sm-border-0">
      <Fragment>
        <Skeleton height={48} width={150} borderRadius={4} />

        <Skeleton height={16} width={385} borderRadius={4} />

        <Skeleton height={16} width={107} borderRadius={4} />
        <Skeleton height={48} width={430} borderRadius={4} />

        <Skeleton height={10} width={430} borderRadius={4} />

        <div className="flex space-between gap-8 ">
          <Skeleton height={40} width={"calc(100% / 4)"} borderRadius={4} />
          <Skeleton height={40} width={"calc(100% / 4)"} borderRadius={4} />

          <Skeleton height={40} width={"calc(100% / 4)"} borderRadius={4} />
          <Skeleton height={40} width={"calc(100% / 4)"} borderRadius={4} />
        </div>

        <Skeleton height={20} width={430} borderRadius={4} />

        <div className="flex space-between gap-8 ">
          <Skeleton height={15} width={15} borderRadius={4} />
          <div className="flex direction-col w-100 gap-8">
            <Skeleton height={16} width={400} borderRadius={4} />
            <Skeleton height={16} width={200} borderRadius={4} />
          </div>
        </div>

        <Skeleton height={48} width={430} borderRadius={4} />

        <Skeleton height={48} width={430} borderRadius={4} />
      </Fragment>
    </Card>
  );
};
